import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { Country, StateRegion, City } from '../models/geography.model';
import { environment } from '../../environments/environment';

// Reads the existing geography reference data (Country / States / Cities) exposed by
// SubscriptionManagement's CommonController. Used to drive the cascading Country -> State ->
// City pickers when creating/editing a location page.
@Injectable({ providedIn: 'root' })
export class GeographyService {
  private readonly baseUrl = environment.subscriptionApiUrl + '/api/Common';
  private countries$?: Observable<Country[]>;

  constructor(private http: HttpClient) {}

  getCountries(): Observable<Country[]> {
    // Countries rarely change; cache for the session.
    if (!this.countries$) {
      this.countries$ = this.http.get<Country[]>(`${this.baseUrl}/GetCountries`).pipe(
        catchError(() => of([] as Country[])),
        shareReplay(1)
      );
    }
    return this.countries$;
  }

  getStatesByCountry(countryId: number): Observable<StateRegion[]> {
    return this.http.get<StateRegion[]>(`${this.baseUrl}/GetStatesByCountryId/${countryId}`).pipe(
      catchError(() => of([] as StateRegion[]))
    );
  }

  getCitiesByState(stateId: number): Observable<City[]> {
    return this.http.get<City[]>(`${this.baseUrl}/GetCitiesByStateId/${stateId}`).pipe(
      catchError(() => of([] as City[]))
    );
  }
}
